import React, {Component} from 'react';
import {Link, withRouter} from 'react-router-dom';
import {connect} from 'react-redux';
import Autorizacao from '../../security/Autorizacao';
import {
    getAdminEmpresa,
    getFiscalEmbarque,
    getGestorEmpresa,
    getMotoristaEmpresa,
    getOperadorEmpresa,
    getPerfisVendedores,
    PERFIL_ADMIN
} from '../../security/securityContext';
import Titulo from '../comum/Titulo';
import selecionarRota from '../../actions/rota/selecionarRota';
import limparItinerarios from '../../actions/itinerario/limparItinerarios'

import BadgeOutlinedIcon from '@mui/icons-material/BadgeOutlined';
import PersonPinOutlinedIcon from '@mui/icons-material/PersonPinOutlined';

export class MenuFechamentoCaixa extends Component {
    
    componentDidMount() {
        this.props.selecionarRota([])
        this.props.limparItinerarios();
    }

    render() {
        return (
            <div className="area-home">
                <Titulo texto="Itinerários" urlRetorno="/"/>
                <div className="row sistemas">
                    <Autorizacao perfisPermitidos={[PERFIL_ADMIN,
                        getOperadorEmpresa(this.props.empresaSelecionada.id),
                        getAdminEmpresa(this.props.empresaSelecionada.id)]}
                        empresaSelecionada={this.props.empresaSelecionada}>
                        <div className="col-6 col-sm-6 col-md-3 mb-3">
                            <Link to="/painel-prestadores">
                                <div className="card card-inicial ">
                                    <div className="card card-inicial-interno ">
                                        <i className="material-icons custom-icons"><BadgeOutlinedIcon className='css-icon' /></i>
                                        <h5 className='nm-longo-resize'>
                                            Prestadores Empresa
                                        </h5>
                                    </div>
                                </div>
                            </Link>
                        </div>
                    </Autorizacao>
                    <Autorizacao perfisPermitidos={[PERFIL_ADMIN,
                        getGestorEmpresa(this.props.empresaSelecionada.id),
                        getOperadorEmpresa(this.props.empresaSelecionada.id),
                        ...getPerfisVendedores(this.props.empresaSelecionada.id),
                        getFiscalEmbarque(this.props.empresaSelecionada.id)]}
                        empresaSelecionada={this.props.empresaSelecionada}>
                        <div className="col-6 col-sm-6 col-md-3 mb-3">
                            <Link to="/painel-itinerarios">
                                <div className="card card-inicial ">
                                    <div className="card card-inicial-interno ">
                                        <i className="material-icons custom-icons">&#xe040;</i>
                                        <h5 className='nm-longo-resize'>
                                            Gerenciar Itinerários
                                        </h5>
                                    </div>
                                </div>
                            </Link>
                        </div>
                    </Autorizacao>
                    <Autorizacao perfisPermitidos={[getOperadorEmpresa(this.props.empresaSelecionada.id),
                        getMotoristaEmpresa(this.props.empresaSelecionada.id),
                        getGestorEmpresa(this.props.empresaSelecionada.id),
                        getAdminEmpresa(this.props.empresaSelecionada.id),
                        getFiscalEmbarque(this.props.empresaSelecionada.id),
                        PERFIL_ADMIN]}
                        empresaSelecionada={this.props.empresaSelecionada}>
                        <div className="col-6 col-sm-6 col-md-3 mb-3">
                            <Link to="/painel-embarque-passageiros">
                                <div className="card card-inicial ">
                                    <div className="card card-inicial-interno ">
                                        <i className="material-icons custom-icons"><PersonPinOutlinedIcon className='css-icon' /></i>
                                        <h5 style={{fontSize: 14}} className='nm-longo'>
                                            Embarque de passageiros
                                        </h5>
                                    </div>
                                </div>
                            </Link>
                        </div>
                    </Autorizacao>
                </div>
            </div>
        );
    }
}

export function mapStateToProps(state) {
    return {
        empresaSelecionada: state.empresaSelecionada,
        authentication: state.authentication
    }
}


export default withRouter(connect(mapStateToProps, {
    selecionarRota,
    limparItinerarios
})(MenuFechamentoCaixa));
